import React from 'react'
import { StoreWrap } from 'xadmin'
import { _t } from 'xadmin-i18n'

const UserNameComponent = StoreWrap('auth.user')(({ user, onLogout, ...props }) => {
  const { justifyContent, alignItems, lineHeight, letterSpacing, color, fontSize, bgColor } = props
  const style = { display: 'flex', height: '100%', wordBreak: 'break-all' }

  if (bgColor) {
    style['backgroundColor'] = bgColor
  }
  if (justifyContent) {
    style['justifyContent'] = justifyContent
  }
  if (alignItems) {
    style['alignItems'] = alignItems
  }
  if (fontSize) {
    style['fontSize'] = fontSize
  }
  if (color) {
    style['color'] = color
  }
  if (letterSpacing) {
    style['letter-spacing'] = letterSpacing
  }
  if (lineHeight) {
    style['line-height'] = lineHeight
  }

  return <div style={style}>{user && user.username}</div>
})

const paramSchema = () => ({
  type: 'object',
  properties: {
    justifyContent: {
      type: 'string',
      title: '主轴对齐',
      enum: ['flex-start', 'flex-end', 'center', 'space-between', 'space-around'],
      enum_title: ['左对齐', '右对齐', '居中', '两端对齐', '两侧的间隔相等']
    },
    alignItems: {
      type: 'string',
      title: '交叉轴对齐',
      enum: ['flex-start', 'flex-end', 'center', 'baseline', 'stretch'],
      enum_title: ['起点对齐', '终点对齐', '中点对齐', '文字基线对齐', '占满容器']
    },
    color: {
      title: '颜色',
      type: 'string',
      fieldType: 'color'
    },
    fontSize: {
      title: '文字大小',
      type: 'number'
    },
    letterSpacing: {
      title: '文字间距',
      type: 'number'
    },
    lineHeight: {
      title: '文字行高',
      type: 'number'
    },
    bgColor: {
      title: '背景颜色',
      type: 'string',
      fieldType: 'color'
    }
  }
})

const UserName = {
  title: '用户名称',
  category: '页面元素',
  icon:require('../icon/用户名称.svg'),
  component: UserNameComponent,
  initLayout: { width: 100, height: 80 },
  paramSchema
}
export default UserName